import { render, staticRenderFns } from "./case5.vue?vue&type=template&id=9f48640a&scoped=true&"
import script from "./case5.vue?vue&type=script&lang=js&"
export * from "./case5.vue?vue&type=script&lang=js&"
import style0 from "./case5.vue?vue&type=style&index=0&id=9f48640a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f48640a",
  null
  
)

export default component.exports